module.exports = __webpack_public_path__ + "img/Light Main Menu.a5098acc.png";